export const routePaths = {
	signIn: '/UserSignin',
	signUp: '/UserSignup',
	home: '/',
	MobileUserSignIn: '/UserSignin',
	MobileCheckout: '/MobileCheckout',
}
